"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.HotelCartClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _eventEmitter = _interopRequireDefault(require("event-emitter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _dateFns = require("date-fns");
const HotelCartClient = {
  /**
   * create a new empty cart
   * @return {Promise<Cart>}
   */
  createEmptyCart(createCartPayload = {}) {
    const requestId = 'CREATE_EMPTY_HOTEL_CART';
    const endPoint = _constants.ENDPOINTS.HOTELS.CREATE_EMPTY_CART;
    return _http.$http.post(requestId, endPoint, {
      data: createCartPayload
    }).then(({
      data
    }) => data);
  },
  /**
   * update cart
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {string} payload.hotelId
   * @param {string} payload.packageId
   * @param {string} payload.availUuid
   * @return {Promise<Cart>}
   */
  updateCart(payload = {}) {
    const requestId = 'UPDATE_HOTEL_CART';
    const endPoint = _constants.ENDPOINTS.HOTELS.UPDATE_CART;
    return _http.$http.put(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * create cart
   * @param {Object} payload
   * @param {string} payload.hotelId
   * @param {string} payload.packageId
   * @param {string} payload.pId
   * @return {Promise<Cart>}
   */
  async createCart(payload = {}, createCartPayload = {}) {
    const {
      cartId
    } = await this.createEmptyCart(createCartPayload);
    return this.updateCart({
      ...payload,
      cartId
    });
  },
  /**
   * get cart
   * @param {Object} payload
   * @param {string} payload.cartId
   * @return {Promise<Cart>}
   */
  getCart({
    cartId
  }) {
    const requestId = 'GET_HOTEL_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.GET_CART, {
      cartId
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * checkout
   * @description checkout hotel cart
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {Array<Object>} payload.traveller
   * @param {string} payload.contact
   * @param {string} payload.payment
   * @param {number} payload.total
   * @param {string} payload.specialRequest
   * @param {string} payload.captcha_token
   * @returns {Promise<Cart>}
   */
  checkout(payload = {}) {
    const requestId = 'CHECKOUT_HOTEL_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.CHECKOUT, {
      cartId: payload.cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * paylater checkout
   * @description paylater checkout
   * @param {Object} payload
   * @param {string} payload.trackId
   * @param {string} payload.orderNumber H01229008050
   * @param {Object} payload.payment
   * @returns {Promise<Cart>}
   */
  payLaterCheckout(payload = {}) {
    const requestId = 'PAYLATER_CHECKOUT_HOTEL_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.PAYLATER_CHECKOUT, {
      trackId: payload.trackId,
      orderNumber: payload.orderNumber
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem qitaf
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */
  redeemQitaf(payload = {}) {
    const requestId = 'QITAF_REDEEM_HOTEL_CART';
    const endPoint = _constants.ENDPOINTS.HOTELS.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem wallet
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */
  redeemWallet(payload = {}) {
    const requestId = 'WALLET_REDEEM_HOTEL_CART';
    const endPoint = _constants.ENDPOINTS.HOTELS.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * apply coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {string} payload.couponCode
   * @param {Object} payload.payment
   * @param {string} payload.payment.method
   * @param {Object} payload.payment.card
   * @param {string} payload.payment.card.number first 6 digits string of card number
   * @param {Object} payload.contact
   * @param {string} payload.contact.firstName
   * @param {string} payload.contact.lastName
   * @param {string} payload.contact.email
   * @param {string} payload.contact.title
   * @param {string} payload.contact.dialCode
   * @param {string} payload.contact.phone
   * @param {Object} payload.contact.specialRequest
   * @param {string} payload.contact.specialRequest.minibar
   * @param {string} payload.contact.specialRequest.smoking
   * @param {Array} payload.contact.specialRequest.bedPreference
   * @param {Array} payload.contact.specialRequest.accessibility
   * @return {Promise<Cart>}
   */
  applyCoupon({
    cartId,
    couponCode,
    ...restPayload
  }) {
    const requestId = 'APPLY_COUPON_HOTELS';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.APPLY_COUPON, {
      cartId,
      couponCode
    });
    return _http.$http.post(requestId, endPoint, {
      data: restPayload
    }).then(({
      data
    }) => data);
  },
  /**
   * remove coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @return {Promise<Cart>}
   */
  removeCoupon({
    cartId
  }) {
    const requestId = 'REMOVE_COUPON_HOTELS';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.REMOVE_COUPON, {
      cartId
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * get order
   * @param {Object} payload
   * @param {string} payload.orderId
   * @param {string} payload.orderNumber
   * @return {Promise<Order>}
   */
  getOrder({
    orderId,
    orderNumber
  }) {
    const requestId = 'GET_HOTEL_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTELS.GET_ORDER, {
      orderId,
      orderNumber
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * get order
   * @param {Object} payload
   * @param {string} payload.orderId
   * @param {string} payload.orderNumber
   * @return {EventEmitter}
   */
  getOrderStream({
    orderId,
    orderNumber
  }) {
    const orderEventEmitter = (0, _eventEmitter.default)();
    let hasData = false;
    const recursiveGetOrder = (0, _debounce2.default)(() => {
      this.getOrder({
        orderId,
        orderNumber
      }).then(data => {
        const bookingStatus = (0, _get2.default)(data, 'status');
        const createdAt = (0, _get2.default)(data, 'createdAt');
        const timeStamp = new Date();
        const utcTimeStamp = timeStamp.getTime() + timeStamp.getTimezoneOffset() * 60000;
        const hasPassedThreeMin = (0, _dateFns.differenceInMinutes)(new Date(utcTimeStamp), new Date(createdAt)) >= _constants.ORDER_POLLING_DURATION_IN_MIN;
        const shouldBreakRecursion = [_constants.BOOKING_STATUS.FAILURE, _constants.BOOKING_STATUS.SUCCESS].includes(bookingStatus) || hasPassedThreeMin;
        if (!hasData || shouldBreakRecursion) {
          hasData = true;
          orderEventEmitter.emit('data', data);
        }
        if (!shouldBreakRecursion) {
          recursiveGetOrder();
        } else {
          orderEventEmitter.emit('end');
        }
      }).catch(error => {
        orderEventEmitter.emit('error', error);
        orderEventEmitter.emit('end');
      });
    }, 3000);
    recursiveGetOrder();
    return orderEventEmitter;
  }
};
exports.HotelCartClient = HotelCartClient;